/** @format */

import React, { useEffect, useState } from "react";
import DamChart from "./damchart";
import DamTable from "./damtable";
import SummaryCallOption from "./DamPnLTable";
import "../Style/homepage.css";
import {
  fetchAllClients,
  fetchAllDamData,
  loginClient,
} from "../api-helper/damapi";
import DamPnLTable from "./DamPnLTable";
import SlidePanelPnL from "./SlidePanelPnl";
import MonthlySummaryTable from "./MonthlySummaryTable";

function HomePage({ submittedEmail, setSubmittedEmail }) {
  const [email, setEmail] = useState("");
  const [allClientEmails, setAllClientEmails] = useState([]);
  const [error, setError] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [password, setPassword] = useState("");
  const [damData, setDamData] = useState([]); // ✅
  const [step, setStep] = useState(0);
  const [totalPnL, setTotalPnL] = useState(0); // Προσθήκη state για total

  // Centralized constants used across components
  const STRIKE = 89;
  const QUANTITY = 10;
  const VOLUME = 1;

  const handleNext = () => setStep((prev) => Math.min(prev + 1, 2));
  const handlePrev = () => setStep((prev) => Math.max(prev - 1, 0));

  const handleSubmit = async (e) => {
    e.preventDefault();
    const lowerEmail = email.trim().toLowerCase();

    try {
      const res = await loginClient(lowerEmail, password); // 👈 login με password
      if (res.success) {
        localStorage.setItem("loggedInEmail", lowerEmail);
        setSubmittedEmail(lowerEmail);
        setError("");
      } else {
        setError("Invalid email or password.");
      }
    } catch (err) {
      setError("Something went wrong.");
    }
  };

  useEffect(() => {
    const savedEmail = localStorage.getItem("loggedInEmail");
    if (savedEmail) {
      setSubmittedEmail(savedEmail);
    }
  }, [setSubmittedEmail]);

  useEffect(() => {
    if (!submittedEmail) return;

    async function loadData() {
      const res = await fetchAllDamData("2025-07-01");

      const processed = res
        .map((entry) => {
          if (!entry.values || entry.values.length === 0) return null;

          const mcpValues = entry.values.map((v) => v.MCP ?? 0);

          // Αν υπάρχει μόνο 1 μη μηδενική τιμή και είναι στην πρώτη ώρα, αγνόησε τη μέρα
          const nonZeroIndices = mcpValues
            .map((v, i) => (v > 0 ? i : -1))
            .filter((i) => i !== -1);
          if (nonZeroIndices.length === 1 && nonZeroIndices[0] === 0) {
            return null;
          }

          const avg =
            mcpValues.reduce((sum, val) => sum + val, 0) / mcpValues.length;

          return {
            date: entry.date,
            avgMCP: +avg.toFixed(2),
          };
        })
        .filter(Boolean)
        .filter((row) => {
          const d = new Date(row.date);
          const month = d.getMonth() + 1;
          const year = d.getFullYear();
          return (
            (year > 2025 || (year === 2025 && month >= 7)) &&
            (year < 2028 || (year === 2028 && month <= 8)) //
          );
        });

      setDamData(processed);
    }

    loadData();
  }, [submittedEmail]);

  return (
    <div className="home-container">
      {!submittedEmail ? (
        <form onSubmit={handleSubmit} className="email-form">
          <h2>Sign in with your email</h2>

          <div className="input-block">
            <label>Email</label>
            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="input-block">
            <label>Password</label>
            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit">Continue</button>

          {error && <p className="error-message">{error}</p>}
        </form>
      ) : (
        <>
          <div className="dashboard-row">
            <DamChart damData={damData} />
            <div style={{ width: "100%", marginTop: 5 }}>
              {step === 2 && (
                <DamPnLTable
                  damData={damData}
                  Total={totalPnL}
                  STRIKE={STRIKE}
                  QUANTITY={QUANTITY}
                  VOLUME={VOLUME}
                />
              )}
              {step === 0 && (
                <SlidePanelPnL
                  isOpen={true}
                  damData={damData}
                  STRIKE={STRIKE}
                  QUANTITY={QUANTITY}
                />
              )}
              {step === 1 && (
                <MonthlySummaryTable
                  damData={damData}
                  onTotalChange={setTotalPnL}
                  STRIKE={STRIKE}
                  QUANTITY={QUANTITY}
                />
              )}

              <div
                className="button-nav"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: 20,
                  padding: "0 32px",
                }}
              >
                {step > 0 && (
                  <button
                    onClick={handlePrev}
                    style={{
                      padding: "10px 20px",
                      backgroundColor: "#1e293b",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      cursor: "pointer",
                    }}
                  >
                    ← {step === 1 ? "VBL Monthly Chart" : "DAM Chart"}
                  </button>
                )}

                {step < 2 && (
                  <button
                    onClick={handleNext}
                    style={{
                      padding: "10px 20px",
                      backgroundColor: "#1d4ed8",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      cursor: "pointer",
                    }}
                  >
                    {step === 0
                      ? "VBL Monthly →"
                      : step === 1
                      ? "DAM Daily Average Price →"
                      : "Next →"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default HomePage;
